import { FC } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useProductReviewFilters } from '../../../../../../lib/hooks/useProductReviewFilters'
import { MultipleSelectFilter } from '../MultipleSelectFilter'
import { RatingsFilter } from '../RatingsFilter'
import { FilterField, OnFilterFieldChange } from '../types'
import { textWithFilterCount } from '../utils'

import { FilterInputSegment } from './FilterInputSegment'
import { ClearFiltersButton, FilterActions, FilterHeadline, Wrapper } from './styles'

export const FilterPanel: FC<{
  fields: FilterField[]
  onRatingChange: OnFilterFieldChange
}> = ({ fields, onRatingChange }) => {
  const {
    magnolia: {
      reviewsPage: {
        filters: { header, filter: filterFixtures, clearAll },
      },
    },
  } = useTranslation()

  const { filters, activeFilterCount, updateFilters } = useProductReviewFilters()

  return (
    <Wrapper>
      <FilterActions>
        <FilterHeadline>{textWithFilterCount(header, activeFilterCount)}</FilterHeadline>
        {activeFilterCount > 0 && (
          <ClearFiltersButton onClick={() => updateFilters({})}>{clearAll}</ClearFiltersButton>
        )}
      </FilterActions>

      <FilterInputSegment
        label={filterFixtures.rating.title}
        selectedFilterCount={filters.rating?.length ?? 0}
      >
        <RatingsFilter value={filters.rating ?? []} onChange={onRatingChange} />
      </FilterInputSegment>

      {fields.map(({ field, value, onChange }) => {
        return (
          <FilterInputSegment
            key={field.fieldId}
            label={field.localizedName ?? field.name}
            selectedFilterCount={value.length}
          >
            <MultipleSelectFilter {...{ value, onChange }} items={field.values} />
          </FilterInputSegment>
        )
      })}
    </Wrapper>
  )
}
